import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../icon';
import { MessageBoxComponent } from './message-box.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  declarations: [
    MessageBoxComponent
  ],
  exports: [
    MessageBoxComponent
  ]
})
export class MessageBoxModule {
}
